import { LngLat } from 'mapbox-gl';
import type { Position } from 'geojson';

/**
 * Coordenadas tal cual las envia el backend (geofield de Drupal), donde los
 * valores viajan como cadena. El constructor de LngLat las convierte con +valor,
 * asi que se aceptan ambas formas.
 */
export interface GeoFieldPoint {
    lat: string | number;
    lon: string | number;
}

/**
 * GeoJSON Point ya parseado. Se usa Position (number[]) y no una tupla de dos
 * porque GeoJSON admite tambien posiciones 3D con altitud.
 */
export interface GeoJsonPointLike {
    coordinates?: Position;
}

/**
 * Stores location data, wrapping MapBox's LngLat
 *
 * @see https://docs.mapbox.com/mapbox-gl-js/api/geography/#lnglat
 */
class GeoLocation extends LngLat {
    // Properties
    // lng
    // lat

    /**
     * Class constructor.
     */
    static fromLatLon(latitude: string | number, longitude: string | number): GeoLocation {
      return new GeoLocation(Number(longitude), Number(latitude));
    }

    /**
     * Construct from Mapbox LngLat
     */
    static fromLngLat(lnglat: LngLat): GeoLocation {
      return new GeoLocation(lnglat.lng, lnglat.lat);
    }

    /**
     * Construct from GeoJson
     */
    static fromGeoJson(txtGeo: string | GeoJsonPointLike): GeoLocation | undefined {
      const geo = typeof txtGeo === 'object' ? txtGeo : JSON.parse(txtGeo) as GeoJsonPointLike;
      if (geo && geo.coordinates) {
        const [lon, lat] = geo.coordinates;
        return new GeoLocation(lon, lat)
      }
      return undefined;
    }

    /**
     * Convert to list (for destructuring).
     *
     * Usage: [lon, lat, zoom] = this.toList();
     */
    toList() {
      return [this.lng, this.lat];
    }
}

export default GeoLocation;
